var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEventChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 -1 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2993 17.7088L3.28929 9.64647C2.90357 9.25824 2.90357 8.62412 3.28929 8.23588L4.22786 7.29118C4.61357 6.90294 5.24357 6.90294 5.62929 7.29118L11.9936 13.6841L18.3707 7.29118C18.7564 6.90294 19.3864 6.90294 19.7721 7.29118L20.7107 8.23588C21.0964 8.62412 21.0964 9.25824 20.7107 9.64647L12.6879 17.7088C12.3021 18.0971 11.685 18.0971 11.2993 17.7088Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventChevronDown);
export default __webpack_public_path__ + "static/media/EventChevronDown.5d7ab0a030970eae97178524194817a9.svg";
export { ForwardRef as ReactComponent };